import { render } from "./CenterList.vue?vue&type=template&id=332f0554"
import script from "./CenterList.vue?vue&type=script&lang=js"
export * from "./CenterList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__